module.exports = __webpack_public_path__ + "media/images/drivuhomescreenimage-85ffb3692b2008ec07b49c7385f347a6.jpg";